import {
    Row,
    Col,
    Typography,
    Table,
    Button,
    message,
  } from "antd";
  import { routes } from "common/routes";
  import { generateHeaders, getSlotName } from "common/utils";
  import { AppPageHeader } from "components/AppPageHeader";
  import { useAppDispatch } from "hooks/useAppDispatch";
  import { useAppSelector } from "hooks/useAppSelector";
  import { useDocumentTitle } from "hooks/usePageTitle";
  import { useEffect, useMemo } from "react";
  import { useNavigate } from "react-router-dom";
import { cancelStoreRejection, removeProcessingWhReturnMapping as removeProcessingStoreReturn, saveStoreRejection } from "store/store-rejection/storeRejectionSlice";

  const MESSAGE_KEY = "SAVE_STORE_RETURN";
  
  export const StoreRejectionPage = () => {
    useDocumentTitle("Store Return Upload Save");
    const { processingStoreRejection, status, error } =
      useAppSelector((state) => state.storeRejection);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
  
    useEffect(() => {
      const { timeUploaded } = processingStoreRejection;
      if (timeUploaded) {
        const uploadedTime = new Date(timeUploaded).getTime();
        const currentTime = new Date().getTime();
        const minsPassed = (currentTime - uploadedTime) / 1000 / 60;
  
        if (minsPassed >= 15) {
          dispatch(removeProcessingStoreReturn());
        }
      }
  
      if (!Object.keys(processingStoreRejection).length) {
        navigate(`/${routes.STORE_REJECTION.INVENTORY_REJECTION_UPLOAD}`);
      }
    }, [dispatch, processingStoreRejection, navigate]);

    // useEffect(() => {
    //   return (() => {
    //     dispatch(removeProcessingStoreReturn())
    //   });
    // }, []);
  
    useEffect(() => {
      if (status === "loading") {
        message.loading({ content: "saving user mapping", key: MESSAGE_KEY });
      } else if (status === "success") {
        message.success({
          content: "User mapping saved!",
          duration: 5,
          key: MESSAGE_KEY,
        });
      } else if (status === "cancelling") {
        message.loading({ content: "cancelling user mapping", key: MESSAGE_KEY });
      } else if (status === "error") {
        message.error({ content: error, key: MESSAGE_KEY });
      }
  
      return () => {
        message.destroy();
      };
    }, [status, error]);
  
    let content;
    const { headerMapping } = processingStoreRejection;
    const { Text } = Typography;
  
    const generateMemoizedHeaders = useMemo(
      () => generateHeaders(headerMapping),
      [headerMapping]
    );
  
    const onSaveUserMapping = () => {
      dispatch(saveStoreRejection());
    };
  
    const onCancelSave = () => {
      dispatch(cancelStoreRejection());
    };
  
    if (!Object.keys(processingStoreRejection).length) {
      content = <Text>Nothing to show here!</Text>;
    } else {
      const headers = generateMemoizedHeaders || {};
      const successRows = processingStoreRejection.successRows;
      const data = successRows?.map((row, i) => ({ ...row, key: `data-${i}` }));
      const columns = [
        ...Object.keys(headers).map(
          (key) =>
            ({
              key,
              title: headers[key],
              dataIndex: key,
            } as any)
        ),
      ];
      content = (
        <Table
          size="small"
          columns={columns}
          dataSource={data}
          pagination={false}
          scroll={{ y: 500 }}
          summary={() => (
            <Table.Summary fixed="bottom">
              <Table.Summary.Row>
                <Table.Summary.Cell index={0} colSpan={2}>
                  <Row>
                    <Col>
                      <Button
                        type="primary"
                        onClick={onSaveUserMapping}
                        loading={status === "loading"}
                        disabled={status === "loading"}
                      >
                        Save Requisition
                      </Button>
                    </Col>
                    <Col style={{ justifyContent: "left", marginLeft: "20px" }}>
                      <Button
                        onClick={onCancelSave}
                        disabled={status === "loading"}
                      >
                        Cancel
                      </Button>
                    </Col>
                  </Row>
                </Table.Summary.Cell>
              </Table.Summary.Row>
            </Table.Summary>
          )}
        />
      );
    }
  
    return (
      <>
        <Row>
          <Col>
            <AppPageHeader title="Save Store Return" />
          </Col>
        </Row>
        <Row>
          <Col xs={24}>{content}</Col>
        </Row>
      </>
    );
  };
  